import React, { useState, useCallback } from "react";
import Notification from "../components/ui/Notification/Notification";

const useNotification = (position = "top-right") => {
  const [notifications, setNotifications] = useState([]);

  const triggerNotification = useCallback((notificationProps) => {
    const id = Date.now();
    setNotifications((prev) => [...prev, { ...notificationProps, id }]);
  }, []);

  const handleClose = useCallback((id) => {
    setNotifications((prev) => prev.filter((n) => n.id !== id));
  }, []);

  const positionClasses = {
    "top-right": "top-5 right-5",
    "top-left": "top-5 left-5",
    "top-center": "top-5 left-1/2 transform -translate-x-1/2",
    "bottom-right": "bottom-5 right-5",
    "bottom-left": "bottom-5 left-5",
  };

  const NotificationComponent = (
    <div
      className={`fixed flex flex-col gap-3 ${positionClasses[position]}`}
      style={{ zIndex: 1500 }}
    >
      {notifications.map((n) => (
        <Notification
          key={n.id}
          {...n}
          onClose={handleClose}
          position={position}
        />
      ))}
    </div>
  );

  return { NotificationComponent, triggerNotification };
};

export default useNotification;
